import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';

import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
import { environment } from 'src/environments/environment';
import { MultiFacilityService } from '../services/multi-facility.service';
import { SubscriptionService } from '../services/subscription.service';
import { bool, IMenuItem, menuConfig, subscriptionsConfig } from './menu.config';
import { MenuModel } from './menu.model';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  openState = false;
  menuItems: IMenuItem[] = [];
  hideLabel = true;
  subList: IMenuItem[] = [];
  viewSubscriptions: IMenuItem;
  cloudBasePath: string;
  isProEnabled = false;
  isHaloTrainingEnabled = false;
  canUpgradeHalo: string;
  private _facilityOnChange: Subscription;
  private _currentFacility: FacilityObject;
  @Input() fcHybridLegacHalo: boolean;
  constructor(
    private _rootScopeService: RootScopeService,
    public facilityService: FacilityService,
    private featureService: FeatureFlagsService,
    private _multiFacilityService: MultiFacilityService,
    private _router: Router,
    private _subscriptionService: SubscriptionService,
    private _loader: HaloLoaderService
  ) {}

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
    this._currentFacility = this.facilityService.selectedFacility();
    this._facilityOnChange = this.facilityService.selectedFacilitySource.subscribe((res) => {
      this._currentFacility = res;
      this.canUpgradeHalo = this._currentFacility.summary.canUpgradeHalo;
    });

    this.facilityService.menus$.subscribe((res) => {
      this.hideLabel = false;
      this.buildMenu(res);
    });

    this.facilityService.menu();
    this.getRootScopeData();
    const multiFacilityPages: string[] = [];
    subscriptionsConfig.forEach((s) => {
      if (s.isMultifacility) multiFacilityPages.push(s.path);
    });
    menuConfig.forEach((s) => {
      if (s.isMultifacility) multiFacilityPages.push(s.path);
    });
    this._multiFacilityService.setMultifacilityUrls(multiFacilityPages);
  }

  ngOnDestroy(): void {
    this._facilityOnChange?.unsubscribe();
  }

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  private _checkPermission(item: IMenuItem, conf: { [k: string]: any }) {
    const facRights: { [k: string]: any } = conf.facilityRights;
    const userRights: { [k: string]: any } = conf.userRights;

    let noPermission = false;
    // Need refactor
    if (item.when?.length) {
      item.when?.forEach((c) => {
        if (!facRights[c] || (facRights[c] && !bool.get(facRights[c])) || (userRights[c] && userRights[c] === 'H')) {
          noPermission = true;
        }

        if (c === 'subscriptions' && conf.isProEnabled === 'true') {
          noPermission = false;
        }
      });
    }

    // check if feature is ON
    if (!noPermission && item.lfFeatureOn) noPermission = !this.featureService.isOn(item.lfFeatureOn);
    if (!noPermission && item.lfFeatureOff) noPermission = !this.featureService.isOff(item.lfFeatureOff);
    if (!noPermission && item.lfFeatureAnyOn) noPermission = !this.featureService.isAnyOn(item.lfFeatureAnyOn);

    return noPermission;
  }

  async buildMenu(menuContext: MenuModel | null) {
    if (!this._currentFacility.summary || !menuContext) return;
    await this.featureService.initialize();

    this.menuItems = [];
    this.subList = [];
    this.isProEnabled = this._currentFacility.summary.isProEnabled === 'true';
    this.isHaloTrainingEnabled =
      this._currentFacility.summary.facilityRights.trainingMenu === 'true' ||
      this._currentFacility.summary.facilityRights.trainingPrograms === 'true' ||
      this._currentFacility.summary.facilityRights.trainingClasses === 'true' ||
      this._currentFacility.summary.facilityRights.membersManage === 'true' ||
      this._currentFacility.summary.facilityRights.membersRetention === 'true' ||
      this._currentFacility.summary.facilityRights.membersPromote === 'true' ||
      this._currentFacility.summary.facilityRights.membersChallenges === 'true';
    const conf: { [k: string]: any } = this._currentFacility.summary;
    //
    if (menuContext.subscriptions && menuContext.subscriptions.length > 0) {
      subscriptionsConfig.forEach((value: IMenuItem, key: string) => {
        if (this._checkPermission(value, conf)) {
          return;
        }
        const keyTemp = key.split('*')[0];
        menuContext.subscriptions.map((item) => {
          //validate
          if (item === keyTemp) {
            if (value.path == 'purchasePlan') {
              this.viewSubscriptions = value;
            } else if (keyTemp.includes('.') && this.subList.length > 0) {
              const child = this.subList[this.subList.length - 1].children?.find((x) => x.path === value.path);
              if (!child) {
                this.subList[this.subList.length - 1].children?.push(value);
              }
            } else {
              value.children = [];
              this.subList.push(value);
            }
          }
        });
      });

      if (!this.isProEnabled && this.isHaloTrainingEnabled) {
        const tmp = this.subList.find((x) => x.when?.includes('trainingMenu'));
        if (tmp) {
          this.subList = [];
          this.subList.push(tmp);
        }
      }
    }
    menuConfig.forEach((value: IMenuItem, key: string) => {
      // validate
      if (this._checkPermission(value, conf)) {
        return;
      }
      const keyTemp = key.split('*')[0];
      if (keyTemp.includes('.')) {
        this.menuItems[this.menuItems.length - 1].children?.push(value);
      } else {
        value.children = [];
        this.menuItems.push(value);
      }
    });

    if (this.fcHybridLegacHalo) this.buildMenuForFcHybridLegacHalo();
  }

  buildMenuForFcHybridLegacHalo() {
    // Hide subscription list if Fc Hybrid Legacy Halo true. And show Announcement and Entertainment Menu Items only.
    this.subList = [];
    const equipmentSettingMenu = this.menuItems.find((menu) => menu.label === 'MENU.EQUIPSETTING') as IMenuItem;
    if (equipmentSettingMenu && equipmentSettingMenu.children) {
      const equipmentSettingMenuItems = equipmentSettingMenu.children.filter((subMenu) =>
        ['ANNOUNCEMENTS', 'ENTERTAINMENT'].includes(subMenu.label)
      );
      const fcHybridEquipmentSettingMenu = {
        ...equipmentSettingMenu,
        expanded: true,
        children: equipmentSettingMenuItems,
      };
      this.menuItems = [fcHybridEquipmentSettingMenu];
    }
  }

  isActive(path: string | null) {
    return path ? window.location.href.includes(path) : false;
  }

  onClick(main: IMenuItem, sub: IMenuItem | null) {
    // toggle
    if (!sub && !!main.children?.length && !this.fcHybridLegacHalo) {
      main.expanded = !main.expanded;
      return;
    }

    // navigate
    let path = main.path || '';

    // sublevel path
    if (sub?.path) path = sub.path;

    // unsaved changes
    this.rootScopeData.pathToNavigate = path; // selected
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      return;
    } else {
      this._navigate(path);
    }
  }

  private _navigate(path: string) {
    // navigate to old app
    if (path?.includes('^')) {
      window.location.href = path.replace('^', '');
      return;
    } else if (path === 'purchasePlan') {
      this._router.navigate(['/subscription/portal_redirect']);
      return;
    }
    // new app
    this._router.navigateByUrl(path);
  }

  onToggle() {
    this.openState = !this.openState;
  }

  goToPurchasePage() {
    if (this._currentFacility.summary.isSubscriptionBannerEnabled === 'true') {
      // TODO: Make it as promise.
      this._loader.startProcess();
      this.facilityService
        .setFacilityUserPreference('isSubscriptionBannerEnabled', false)
        .then()
        .finally(() => {
          this._subscriptionService.getToken();
          this._loader.endProcess();
        });
    } else {
      this._subscriptionService.getToken();
    }
  }
}
